<div class="register-page-wrapper">
  <payee-header></payee-header>
  <div class="header-divider"></div>

  <div class="register-container-wrapper">
    <div class="register-container">
      <h1 class="register-title">{{ "REGISTER.TITLE" | translate }}</h1>

      <form
        class="register-form"
        [formGroup]="registerForm"
        (ngSubmit)="register()"
      >
        <div class="form-field-wrapper">
          <span class="form-label">
            {{ "REGISTER.EMAIL_LABEL" | translate }}
          </span>
          <payee-form-field
            width="wide"
            class="form-field"
          >
            <input
              payee-input
              formControlName="email"
              type="email"
              autocomplete="email"
              inputmode="email"
              class="form-input"
              data-testid="signup-email"
            />
            @if (email.dirty) {
              <ng-container payee-error>
                @if (email.hasError("email")) {
                  <mat-error>
                    {{ "ERROR_MESSAGES.INVALID_EMAIL" | translate }}
                  </mat-error>
                }
                @if (email.hasError("required")) {
                  <mat-error>
                    {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                  </mat-error>
                }
                @if (email.hasError("used")) {
                  <mat-error>
                    {{ "REGISTER.EMAIL_ALREADY_REGISTERED" | translate }}
                  </mat-error>
                }
              </ng-container>
            }
          </payee-form-field>
        </div>

        <div class="terms-text-wrapper">
          <p class="terms-text">
            <span>{{ "REGISTER.TERMS_TEXT" | translate }}</span>
            <a
              href="https://www.payee.tech/legal/terms-and-conditions"
              target="_blank"
              class="terms-link"
            >
              {{ "REGISTER.TERMS_CONDITIONS" | translate }}
            </a>
            <span>&nbsp;{{ "REGISTER.AND" | translate }}&nbsp;{{ "REGISTER.AND_THE" | translate }}&nbsp;</span>
            <a
              href="https://www.payee.tech/legal/privacy-policy"
              target="_blank"
              class="terms-link"
            >
              {{ "REGISTER.PRIVACY_POLICY" | translate }}
            </a>
            <span>.</span>
          </p>
        </div>

        @if (registerForm.hasError("unknown")) {
          <mat-error class="form-error">
            {{ registerForm.getError("unknown") }}
          </mat-error>
        }

        <input
          type="submit"
          hidden
        />

        <button
          payee-button
          width="wide"
          height="tall"
          color="blue-payee"
          type="submit"
          data-testid="signup-submit"
          [disabled]="loading()"
        >
          @if (!loading()) {
            <span>{{ "REGISTER.CONTINUE" | translate }}</span>
          }
          @if (loading()) {
            <span>{{ "REGISTER.LOADING" | translate }}</span>
          }
        </button>

        <!-- Secondary CTA -->
        <a routerLink="/login">
          <button
            type="button"
            payee-button
            width="wide"
            color="white"
            height="tall"
            [isBorderButton]="true"
          >
            {{ "REGISTER.LOGIN_CTA" | translate }}
          </button>
        </a>
      </form>

      <div class="separator">
        <div class="separator-line"></div>
        <span class="separator-text">
          {{ "LOGIN.OR_SEPARATOR" | translate }}
        </span>
        <div class="separator-line"></div>
      </div>

      <div class="flex column social-logins">
        <app-google-sso-button [ssoUrl]="googleSSOUrl"></app-google-sso-button>

        <a routerLink="/sso/szamlazzhu">
          <button
            type="button"
            payee-button
            width="wide"
            color="white"
            height="tall"
            [isBorderButton]="true"
          >
            <span class="social-login-text">
              <img
                src="assets/szamlazzhu_logo-vertical-2_orange.png"
                alt="Számlázz.hu"
                class="szamlazzhu-logo"
              />
              {{ "LOGIN.CONTINUE_WITH_SZAMLAZZ" | translate }}
            </span>
          </button>
        </a>
      </div>
    </div>
  </div>

  <app-footer-simple></app-footer-simple>
</div>
